import React from 'react';
import { useIntl } from 'react-intl';
import { FlexBox } from '../../FlexBox';
import { Typography } from '@mui/material';
import CircleRoundedIcon from '@mui/icons-material/CircleRounded';

const StatusInfo = function StatusInfo({ value, optionsColors, fontSize }) {
  const intl = useIntl();
  return !value &&
    !intl.messages[value?.toUpperCase()] &&
    optionsColors[value?.toUpperCase()] ? (
    <div />
  ) : (
    <FlexBox alignItems="center">
      <CircleRoundedIcon
        sx={{ color: optionsColors[value?.toUpperCase()] || 'greys.darker' }}
      />
      <Typography
        variant="body2"
        sx={{ fontWeight: 'bold', ml: '3%', fontSize }}
        title={intl.messages[value?.toUpperCase()]}
      >
        {intl.messages[value?.toUpperCase()]}
      </Typography>
    </FlexBox>
  );
};
export default StatusInfo;
